/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:50:36
 * @LastEditTime: 2023-11-06 18:18:06
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\TerminalflowDimensionRouter.js
 * 终端流向维度
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
const TerminalflowDimensionRouter = [
  // 终端/商业进货统计
  {
    path: '/flowSystem/client-purchase-statistics',
    name: 'flowSystemStatisticsClientPurchase',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/statistics/ClientPurchase.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/Terminal-commercial-purchase-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端/商业进货统计'
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    }
  },
  // 终端进货分析
  {
    path: '/flowSystem/client-sales-statistics',
    name: 'flowSystemStatisticsClientSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics2" */
      //   '../views/flowSystem/statistics/ClientSales.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics2" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/purchase-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端进货分析'
    }
  },
  // 终端亩产分析
  {
    path: '/flowSystem/per-mu-of-client-statistics',
    name: 'flowSystemStatisticsPerMuOfClient',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/PerMuOfClient.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/yieldper-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端亩产分析'
    }
  },
  // 终端亩产分析 低于终端亩均数明细
  {
    path: '/flowSystem/per-mu-of-client-statistics-detail',
    name: 'flowSystemStatisticsPerMuOfClientDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/PerMuOfClientDetail.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/yieldper-analy/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端明细',
      breadcrumb: [
        {
          title: '终端亩产分析',
          name: 'flowSystemStatisticsPerMuOfClient'
        }
      ]
    }
  },
  // 终端退货分析
  {
    path: '/flowSystem/client-return-statistics',
    name: 'flowSystemStatisticsClientReturn',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/ClientReturn.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/return-analy/Page.vue'
      ), //新迁移文件

    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端退货分析'
    }
  },
  // 连锁分销统计
  {
    path: '/flowSystem/distribution-statistics',
    name: 'flowSystemStatisticsDistribution',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/Distribution.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/chain-distribution-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '连锁分销统计'
    }
  },
  // 导入连锁门店数量
  {
    path: '/flowSystem/stores-count',
    name: 'flowSystemStatisticsStoresCount',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/StoresCount.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/chain-distribution-statis/ImportCount.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '导入连锁门店数量',
      breadcrumb: [
        {
          title: '连锁分销统计',
          name: 'flowSystemStatisticsDistribution'
        }
      ]
    }
  },
  // 导入连锁门店排序
  {
    path: '/flowSystem/stores-sort',
    name: 'flowSystemStatisticsStoresSort',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/StoresSort.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/chain-distribution-statis/ImportSort.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '导入连锁门店排序',
      breadcrumb: [
        {
          title: '连锁分销统计',
          name: 'flowSystemStatisticsDistribution'
        }
      ]
    }
  },
  // 终端流向维度报表中心
  {
    path: '/flowSystem/ReportCenter-statistics',
    name: 'flowSystemStatisticsReportCenter',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/ReportCenter.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/report-center/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '报表中心'
    }
  },
  // 终端覆盖统计
  {
    path: '/flowSystem/ClientCover-statistics',
    name: 'flowSystemStatisticsClientCover',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/ClientCover.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/coverage-statis/Page.vue'
      ),
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '终端覆盖统计'
    }
  },
  // 终端覆盖统计   未购进客户明细
  {
    path: '/flowSystem/customers-not-purchased',
    name: 'CustomersNotPurchased',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/coverage-statis/customers-not-purchased/Page.vue'
      ),
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '未购进客户明细',
      breadcrumb: [
        {
          title: '终端覆盖统计',
          name: 'flowSystemStatisticsClientCover'
        }
      ]
    }
  },
  // 终端流向维度 客户统计
  {
    path: '/flowSystem/Customer-statistics',
    name: 'CustomerStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/Customer.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/customer-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '客户统计'
    }
  },
  // 客户统计  新增客户统计
  {
    path: '/flowSystem/NewCustomerDetails/:month_date/:goodsList/:cls/:province_id',
    name: 'NewCustomerDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/NewCustomerDetails.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/customer-statis/Add.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '新增客户明细',
      breadcrumb: [
        {
          title: '客户统计',
          name: 'CustomerStatistics'
        }
      ]
    }
  },
  // 客户统计  下降客户统计
  {
    path: '/flowSystem/ReduceCustomerDetails/:month_date/:goodsList/:cls/:province_id',
    name: 'ReduceCustomerDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/ReduceCustomerDetails.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/Terminal-flow-dimension/customer-statis/Descend.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '终端流向维度', //二级菜单
      title: '下降客户明细',
      breadcrumb: [
        {
          title: '客户统计',
          name: 'CustomerStatistics'
        }
      ]
    }
  }
]
export default TerminalflowDimensionRouter
